import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  OrderCustomFieldsWithinFieldsetInput,
  OrderCustomFieldsWithinFieldsetMutation,
} from '@/gql/graphql';

const ORDER_CUSTOM_FIELDS_WITHIN_FIELDSET_MUTATION = graphql(`
  mutation OrderCustomFieldsWithinFieldset(
    $input: OrderCustomFieldsWithinFieldsetInput!
  ) {
    orderCustomFieldsWithinFieldset(input: $input) {
      id
    }
  }
`);

const useOrderCustomFieldsWithinFieldset = (
  options?: UseMutationOptions<
    OrderCustomFieldsWithinFieldsetMutation,
    unknown,
    OrderCustomFieldsWithinFieldsetInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(ORDER_CUSTOM_FIELDS_WITHIN_FIELDSET_MUTATION, {
        input,
      });
    },
    ...options,
  });
};

export default useOrderCustomFieldsWithinFieldset;
